import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

type Props = {
  errorMessage: string;
};

const AppServerError: React.FC<Props> = ({ errorMessage }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleGoToSandbox = () => {
    history.push('/sandbox');
  };

  return (
    <div className="app-loading-container">
      <Container className="d-flex flex-column align-items-center justify-content-center min-vh-100">
        <div>
          <h4>{t('general.appError')}</h4>
          <div className="text-center">{errorMessage}</div>
          {import.meta.env.MODE !== 'production' && (
            <div className="text-center mt-3">
              <Button variant="outline-primary" onClick={handleGoToSandbox}>
                Go to Sandbox
              </Button>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default AppServerError;
